export default __webpack_public_path__ + "static/media/1814.71b5accc.png";